import React from 'react';
import { t } from 'i18next';
import { Modal } from '@brighterion/br-ui';
import { useNotificationsStore } from 'Hooks/zustand/useNotificationsStore';
import useDeleteScheduledDeployment from 'Hooks/query-hooks/scheduled-deployment/useDeleteScheduledDeployment';
import type { ScheduledDeployment } from 'Hooks/query-hooks/scheduled-deployment/useGetScheduledDeployment';
import type { ScheduledDeploymentContentProps } from '../ScheduledDeploymentContent';

import styles from './Delete.css';

export const Delete: React.FC<ScheduledDeploymentContentProps & { scheduledDeployment: ScheduledDeployment }> = ({
    children,
    closeModal,
    modal,
    scheduledDeployment,
    status,
    ...props
}) => {
    const mutation = useDeleteScheduledDeployment(scheduledDeployment);
    const setOperation = useNotificationsStore((state) => state.setOperation);

    const { id, name, title } = modal;

    const handleAction = () => {
        closeModal();
        setOperation('create');
    };

    const handleClick = () => {
        mutation.mutate(undefined, {
            onSuccess: handleAction
        });
    };

    return (
        <>
            <Modal.Title id={name ?? id} onClose={closeModal} statusIcon={status} title={title} />
            <div className={styles.container} {...props}>
                {children}
            </div>
            <Modal.Footer
                id={name ?? id}
                onClose={handleAction}
                onCloseText={t('Deploy as Scheduled')}
                onAction={handleClick}
                onActionText={t('Cancel Deployment')}
            />
        </>
    );
};
